import { GLOBAL } from '@/store/types'

const Global = {
  namespaced: true,
  state: {
    message: '',
    messageValue: null,
    loading: false
  },
  getters: {
    showMessage (state) {
      return state.message !== ''
    },
    loading (state) {
      return state.loading
    }
  },
  mutations: {
    [GLOBAL.SET_MESSAGE] (state, obj) {
      state.message = obj.message
      if(obj.messageValue) {
        state.messageValue = obj.messageValue
      } else {
        state.messageValue = []
      }
    },
    [GLOBAL.RESET_MESSAGE] (state) {
      state.message = ''
      state.messageValue = null
    },
    [GLOBAL.SET_LOADING] (state, value) {
      state.loading = value
    }
  },
  actions: {
    showMessage ({commit}, obj) {
      commit(GLOBAL.SET_MESSAGE, obj)
    },
    hideMessage ({commit}) {
      commit(GLOBAL.RESET_MESSAGE)
    },
    showLoading ({commit}) {
      commit(GLOBAL.SET_LOADING, true)
    },
    hideLoading ({commit}) {
      commit(GLOBAL.SET_LOADING, false)
    }
  }
}

export default Global
